<template>
  <div class="base-select pcStyle" v-clickoutside="clickoutside">
    <div class="base-select-title el-dropdown-link" :class="{active: isDropdown}" @click="toggleDropdown">
      <div class="select-val" :class="{ placeholder: !inputVal }">
        <input :placeholder="placeHolder" v-model="inputVal" type="text" />
      </div>
      <div class="arrow">
        <img v-show="!isDropdown" class="arrow-icon arrow-up" src="@/assets/images/down-icon.png" alt="" />
        <img v-show="isDropdown" class="arrow-icon arrow-up" src="@/assets/images/dropdown.png" alt="" />
      </div>
    </div>
    <div class="base-select-dropdown" :style="{ height: `${dropdownHeight}px` }">
      <ul class="base-dropdown-panel">
        <li
          class="dropdown-item"
          v-for="item in filterDropdownList"
          :key="item.countryCode"
          @click="select(item)"
        >{{ item.countryName || item.enUs }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex';
  export default {
    data() {
      return {
        isDropdown: false,
        dropdownHeight: 0,
        inputVal: '',
      };
    },
    computed: {
      ...mapGetters('independentMarketing', ['GET_COUNTRY_LIST', 'GET_SELECT_COUNTRY']),
      placeHolder() {
        return this.i18n.independentMarketing.common.hintSelect;
      },
      filterDropdownList() {
        return this.GET_COUNTRY_LIST.filter(item => {
          let countryNameStr = (item.countryName || item.enUs || '').toLowerCase();
          let inputValStr = this.inputVal.toLowerCase();
          return countryNameStr.includes(inputValStr);
        });
      },
    },
    methods: {
      ...mapMutations('independentMarketing', ['SET_SELECT_COUNTRY']),
      select(item) {
        this.inputVal = item.countryName || item.enUs;
        this.hideDropdown();
        if (item.countryCode === this.GET_SELECT_COUNTRY?.countryCode) return;
        this.SET_SELECT_COUNTRY(item);
      },
      clickoutside() {
        if (this.inputVal !== this.GET_SELECT_COUNTRY?.countryName && this.inputVal !== this.GET_SELECT_COUNTRY?.enUs) {
          this.inputVal = '';
        }
        this.hideDropdown();
      },
      hideDropdown() {
        this.dropdownHeight = 0;
        this.isDropdown = false;
      },
      toggleDropdown() {
        this.isDropdown = !this.isDropdown;
        if (this.isDropdown) {
          this.dropdownHeight = this.GET_COUNTRY_LIST.length * 32 + 2;
        } else {
          this.dropdownHeight = 0;
        }
      },
    },
  };
</script>
<style lang="less" scoped>
.base-select.pcStyle {
  position: relative;
  .base-select-title {
    height: 44px;
    line-height: 44px;
    background: #fff;
    border: 1px solid #aaa;
    border-radius: 4px;
    padding-left: 15px;
    padding-right: 42px;
    position: relative;
    text-align: left;
    user-select: none;
    cursor: pointer;
    box-sizing: border-box;
    &.active {
      border: 1px solid #007aff;
    }
    .placeholder {
      color: #888;
    }
    .arrow {
      position: absolute;
      right: 0;
      top: 0;
      width: 40px;
      height: 40px;
      border-radius: 0px 4px 4px 0px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      .arrow-icon {
        width: 20px;
        height: 20px;
        transform: rotate(180deg);
        transition: all 0.3s;
      }
      .arrow-up {
        transform: rotate(0deg);
        transition: all 0.3s;
      }
    }
    .select-val {
      input {
        height: 42px;
        width: 100%;
        box-sizing: border-box;
        padding: 0;
        vertical-align: top;
        border: none;
        &:focus-visible {
          outline: none;
        }
      }
    }
  }
  .base-select-dropdown {
    position: absolute;
    left: 0;
    top: 48px;
    width: 100%;
    height: 0;
    max-height: 300px;
    overflow: hidden;
    // transition: all 0.3s;
    z-index: 999;
    .base-dropdown-panel {
      height: 100%;
      max-height: 300px;
      overflow: auto;
      margin: 0;
      text-align: left;
      font-size: 0;
      box-sizing: border-box;
      background: #ffffff;
      box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.05), 0px 4px 5px 0px rgba(0, 0, 0, 0.08),
        0px 2px 4px -1px rgba(0, 0, 0, 0.12);
      border-radius: 3px;
      border: 1px solid #dcdcdc;
      padding: 8px 20px 8px 5px;
      .dropdown-item {
        list-style: none;
        cursor: pointer;
        padding: 8px 10px;
        line-height: 16px;
        font-size: 14px;
        color: #000;
        &:hover {
          color: #007aff;
          background: #eaf4ff;
          border-radius: 3px;
        }
        &.active {
          color: #007aff;
        }
      }
    }
  }
}
</style>
